import { computed, inject } from 'vue';
import { defaultConfigProvider } from '../../config-provider';
export default (name, props) => {
    const configProvider = inject('configProvider', defaultConfigProvider);
    const prefixCls = computed(() => configProvider.getPrefixCls(name, props.prefixCls));
    const direction = computed(() => { var _a; return (_a = props.direction) !== null && _a !== void 0 ? _a : configProvider.direction; });
    const rootPrefixCls = computed(() => configProvider.getPrefixCls());
    const autoInsertSpaceInButton = computed(() => configProvider.autoInsertSpaceInButton);
    const renderEmpty = computed(() => configProvider.renderEmpty);
    const space = computed(() => configProvider.space);
    const pageHeader = computed(() => configProvider.pageHeader);
    const form = computed(() => configProvider.form);
    const getTargetContainer = computed(() => props.getTargetContainer || configProvider.getTargetContainer);
    const getPopupContainer = computed(() => props.getPopupContainer || configProvider.getPopupContainer);
    const virtual = computed(() => { var _a; return (_a = props.virtual) !== null && _a !== void 0 ? _a : configProvider.virtual; });
    const dropdownMatchSelectWidth = computed(() => { var _a; return (_a = props.dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : configProvider.dropdownMatchSelectWidth; });
    const size = computed(() => props.size || configProvider.componentSize);
    return {
        configProvider,
        prefixCls,
        direction,
        size,
        getTargetContainer,
        getPopupContainer,
        space,
        pageHeader,
        form,
        autoInsertSpaceInButton,
        renderEmpty,
        virtual,
        dropdownMatchSelectWidth,
        rootPrefixCls,
    };
};
